module.exports = __webpack_public_path__ + "global-networkn-bf00d8cd.webp";